import { render, staticRenderFns } from "./ModalStock.vue?vue&type=template&id=20392aac&"
import script from "./ModalStock.vue?vue&type=script&lang=js&"
export * from "./ModalStock.vue?vue&type=script&lang=js&"
import style0 from "./ModalStock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports